// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__2ceWv","errorLogs":"EditorFooter_errorLogs__12abH"};